<template>
  <div class="course">
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="courseList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="px-list" v-if="loading || courseList.length > 0">
        <PxItem
          class="px-list-item"
          v-for="item in courseList"
          :key="item.id"
          :cover="item.cover"
          :title="item.title"
          :price="item.curriculumPrice"
          :saleType="item.saleType"
          :author="item.publisher"
          :number="item.enrollment"
          @click.native="toCourseDetails(item.id, item.goodsId)"
        />
      </div>
      <noneList noneType="collect" v-else />
    </van-list>
  </div>
</template>
    
    <script>
import PxItem from "@/views/mobileView/components/listItem/pxItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "course",
  components: {
    PxItem,
    noneList,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      courseList: [],
      curPage: 1,
    };
  },
  methods: {
    async getUserCollectCurriculumList() {
      this.loading = true;
      const resp = await this.$apis.userServe.getUserCollectCurriculumList({
        pageSize: 6,
        pageNo: this.curPage,
      });
      if (resp.resultCode == 200) {
        this.courseList = resp.data.list;
        this.finished = resp.data.list.length < 20 ? true : false;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    onLoad() {
      if (sessionStorage.getItem("token")) {
        this.getUserCollectCurriculumList();
      } else {
        this.finished = true;
        Toast("请先登录");
      }
    },
    toCourseDetails(id, goodsId) {
      this.$router.push({
        name: "courseDetails",
        query: {
          type: 9,
          id,
          goodsId,
        },
      });
    },
  },
};
</script>
    
    <style lang="scss" scoped>
.course {
  width: 100%;
  height: 100%;
  .px-list {
    margin-top: 12px;
    .px-list-item {
      display: inline-block;
      margin: 12px 10px 0 12px;
      width: 170px;
      border-radius: 6px;
      background-color: #fff;
      overflow: hidden;
      &:nth-child(2n) {
        margin-left: 1px;
        margin-right: 10px;
      }
    }
  }
}
</style>